import React from 'react'
import PartnershipsLayout from 'components/PartnershipsSite/PartnershipsLayout'
import ListSection from 'components/PartnershipsSite/ListSection'
import { usePageView } from 'hooks'
import { getStaticWrapper, THEME } from 'utils'
import PageHeader from 'components/PartnershipsSite/PageHeader'
import PhotoQuote from 'components/PartnershipsSite/PhotoQuote'

const SectionBreak = ({ backgroundColor = '#de4444', children }) => {
  return (
    <div className='sectionBreak'>
      {children}
      <style jsx>{`
        .sectionBreak {
          background-color: ${backgroundColor};
          width: 100%;
          padding: 1.5rem;
          color: #ffffff;
          font-size: 0.8rem;
          text-align: center;
        }
        @media (min-width: 370px) {
          .sectionBreak {
            font-size: 0.85rem;
          }
        }
        @media (min-width: 400px) {
          .sectionBreak {
            font-size: 0.9rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
          .sectionBreak {
            padding: 2.5rem;
            font-size: 1.1rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .sectionBreak {
            padding: 3rem 3.5rem;
            font-size: 1.3rem;
          }
        }
      `}</style>
    </div>
  )
}

const SponsorshipAudienceTargeting = () => {
  usePageView()

  return (
    <PartnershipsLayout background='#D8D8D8'>
      <div className='creativeServices'>
        <PageHeader
          title={'AUDIENCE TARGETING'}
          details={'Reach our hyper-engaged audience wherever their passions lie'}
        />
        <PhotoQuote
          img={'https://chumley.barstoolsports.com/union/2021/06/09/CFBset-_Blue.65ee95e8.png'}
          text={[
            'Video and display opportunities to surround hundreds of pieces of content released weekly across all platforms and devices'
          ]}
        />
        <SectionBreak>
          <h2>Direct Buy</h2>
        </SectionBreak>
        <ListSection
          header='Audio Pre-Roll'
          subheader='Barstool Sports is a Top 10 podcast network garnering 40M monthly downloads. Brands have the opportunity to reach our large podcast audience at scale with our latest turnkey DAI audio pre-roll solution.'
          list={[
            'Our brand partners now have the ability to run their audio advertisements in front of our Podcast programming.',
            'Targeting capabilities are available to cater to particular brand target consumers, flight dates, or content alignment.'
          ]}
        />
        <ListSection
          header='Video Solution'
          subheader="Pre-roll, Mid-roll, and Post-Roll surrounding Barstool's large library of original video content reaching 41M monthly video views."
          list={[
            "Brand partners' video assets can run across Barstool's video programming on O&O and YouTube inventory.",
            'Targeting capabilities are available to cater to flight dates or Barstool franchise alignment.'
          ]}
        />
        <ListSection
          header='Display Capabilities'
          subheader="Target Barstool's 51M+ monthly pageviews with our display solutions across web, app and email."
          img='https://chumley.barstoolsports.com/union/2021/06/01/transfusion.2c69fd64.png?crop=0.99%2C0.86%2Cx0.00%2Cy0.14%2Csafe&format=png'
          list={[
            "Reach Barstool's large audience across O&O.",
            'Targeting capabilities are available to cater to flight dates or geography.'
          ]}
        />
        <SectionBreak>
          <h2>Self-Service</h2>
        </SectionBreak>
        <ListSection
          header='Barstool Audience Network'
          subheader='Our brand partners have the ability to buy Barstool audiences and/or Barstool purchasers to target off-platform for their own campaigns.'
          list={[
            'Maximize brand results with a simple self-service campaign ad manager.',
            'Manage and optimize brand campaigns in real-time.',
            'Video pre-roll/mid-roll/post-roll will run across the Barstool Blog (Web & App) and Barstool YouTube Channels.',
            'Display will run across Barstool Blog (Web & App).',
            'Targeting capabilities are available to cater to particular brand target consumers, flight dates, or content alignment.'
          ]}
          subLists={[
            {
              header: 'How it works',
              items: [
                'Login or Create a Login (you will need to create one login for Display campaign ads manager and a seperate one for Video campaign ads manager).',
                'Choose your flight - determine when you want your campaign to run.',
                'Determine your audience.',
                'Targeting capabilities include.',
                <ul key={0} style={{ listStyleType: 'square', color: '#de4444' }}>
                  <li>Video: Geography (Country, State) and Franchise/Talent Content Targeting</li>
                  <li>Display: Geography (Country, State, City, Zip Code), Device or Operating System</li>
                </ul>,
                'Set your campaign budget.',
                'Upload your ad for review - your campaign will not begin until approved by Barstool Sports; campaigns can begin 4 days from submission.',
                'Input credit card details - safe and secure payment processing.',
                'Measure ad performance within the ads manager.'
              ]
            }
          ]}
        />
        <SectionBreak backgroundColor='#11192a'>
          <h2>
            <a href='https://barstoolaudiencenetwork.com/' style={{ color: 'inherit', textDecoration: 'underline' }}>
              Click Here
            </a>
            &nbsp;to get started
          </h2>
        </SectionBreak>
        <ListSection
          header='Barstool Audience Extension'
          subheader='Our brand partners have the ability to buy Barstool audiences to target off-platform for their own campaigns.'
          list={[
            "Target Barstool's audience off-platform.",
            'Turnkey solution for an array of campaign budgets.',
            'Measure and manage your campaigns in real-time.'
          ]}
          subLists={[
            {
              header: 'How to buy',
              items: [
                'Self-Service.',
                'Monthly licensing fee based on audience size.',
                'Buy for a specific flight period.'
              ]
            }
          ]}
        />
      </div>
    </PartnershipsLayout>
  )
}

export const getStaticProps = getStaticWrapper()

export default SponsorshipAudienceTargeting
